enum IncidentStatus {
  Draft = 0,
  Completed = 1,
}

export default IncidentStatus;
